import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

const EVENT_CATEGORY = EVENT_CATEGORIES.MARKETPLACE_LOANS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

const INCOME_CONFIRMATION_LABEL = 'Подтверждение дохода';
const HOW_WE_SEND_APPLICATION_LABEL = 'Как отправим заявку';
const ANKETA_LABEL = 'Анкета';

export type TIncomeConfirmationOption = 'esia' | 'regular';

export type TIncomeConfirmationAnalyticsEventData = {
  scenario: string;
  searchOutput: number;
  offerType: string;
  filter: string;
  category: number;
  subCategory: number;
  calcId: string | null;
  productId: string | number | null;
  productName: string;
  organizationId: string | number;
  organizationName: string;
  offerIndex: number;
  psk?: string | null;
  sum?: string | null;
  rate?: string | null;
  term?: string | null;
  badges: string;
  timeOnPage: number;
};

const INCOME_CONFIRMATION_OPTION_LABELS: Record<
  TIncomeConfirmationOption,
  { applicationType: string; confirmationType: string }
> = {
  esia: { applicationType: 'ГУ', confirmationType: 'С подтверждением' },
  regular: { applicationType: 'Обычная', confirmationType: 'Без подтверждения' },
};

const getIncomeConfirmationOfferLabelParts = (data: TIncomeConfirmationAnalyticsEventData) => {
  const {
    scenario,
    searchOutput,
    offerType,
    filter,
    category,
    subCategory,
    calcId,
    productId,
    productName,
    organizationId,
    organizationName,
    offerIndex,
    psk,
    sum,
    rate,
    term,
    badges,
    timeOnPage,
  } = data;

  return [
    scenario,
    searchOutput,
    offerType,
    filter,
    `Категория - ${category}`,
    `Подкатегория - ${subCategory}`,
    calcId,
    productId,
    offerIndex,
    organizationId,
    organizationName,
    productName,
    psk ? `ПСК - ${psk}` : '',
    sum ? `Сумма - ${sum}` : '',
    rate ? `Ставка - ${rate}` : '',
    term ? `Срок - ${term}` : '',
    badges,
    `Время - ${timeOnPage}`,
  ];
};

export const eventOnShowIncomeConfirmationPlaque = (data: TIncomeConfirmationAnalyticsEventData): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ',
  eventLabel: [INCOME_CONFIRMATION_LABEL, ANKETA_LABEL, ...getIncomeConfirmationOfferLabelParts(data)].join(' | '),
  eventValue: undefined,
});

export const eventOnClickIncomeConfirmationPlaque = (
  data: TIncomeConfirmationAnalyticsEventData,
  option: TIncomeConfirmationOption,
): IInitialEvent => {
  const { confirmationType } = INCOME_CONFIRMATION_OPTION_LABELS[option];

  return {
    event: EVENT_TYPE,
    eventCategory: EVENT_CATEGORY,
    eventAction: 'Клик',
    eventLabel: [
      INCOME_CONFIRMATION_LABEL,
      ANKETA_LABEL,
      confirmationType,
      ...getIncomeConfirmationOfferLabelParts(data),
    ].join(' | '),
    eventValue: undefined,
  };
};

export const eventOnShowHowWeSendApplicationModal = (data: TIncomeConfirmationAnalyticsEventData): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ',
  eventLabel: [HOW_WE_SEND_APPLICATION_LABEL, ...getIncomeConfirmationOfferLabelParts(data)].join(' | '),
  eventValue: undefined,
});

export const eventOnClickHowWeSendApplicationModal = (
  data: TIncomeConfirmationAnalyticsEventData,
  option: TIncomeConfirmationOption,
): IInitialEvent => {
  const { applicationType, confirmationType } = INCOME_CONFIRMATION_OPTION_LABELS[option];

  return {
    event: EVENT_TYPE,
    eventCategory: EVENT_CATEGORY,
    eventAction: 'Клик',
    eventLabel: [
      HOW_WE_SEND_APPLICATION_LABEL,
      applicationType,
      ANKETA_LABEL,
      confirmationType,
      ...getIncomeConfirmationOfferLabelParts(data),
    ].join(' | '),
    eventValue: undefined,
  };
};
